module.exports = __webpack_public_path__ + "static/media/fondo_horizontal.2700295b.bin";